import { Chip } from "@mui/material";

export default function TipoInstalacao({ 
  tipoInstalacao, 
  tipoComercializacao = null, 
  tipoLicenciamento = null, 
  tipoServico = null,
  tipoPlano = null,
  isPonto = false, 
  isPedido = false 
}) {
  const getStatus = () => {
    if ((!tipoComercializacao && tipoInstalacao === 0) || tipoComercializacao === 1) {
      return {
        color: tipoLicenciamento === 1 ? 'darkgreen' : 'tomato',
        label: tipoLicenciamento === 1 ? 'Lic. Anual' : 'Licenciado',
      };
    }

    if ((!tipoComercializacao && tipoInstalacao === 1) || (tipoComercializacao === 2 && (!isPonto || tipoPlano === 1))) {
      const isOnPrem = tipoServico === 1;

      return {
        color: isOnPrem ? 'blue' : 'deepskyblue',
        label: isOnPrem ? (isPonto ? 'On Premisse (Rep-C)' : 'On Premisse') : (isPonto ? 'SaaS (Rep-C)' : 'SaaS'),
      };
    }

    if ((isPonto && !tipoComercializacao && tipoInstalacao === 2) || (tipoComercializacao === 2 && tipoPlano === 2)) {
      const isOnPrem = tipoServico === 1;
      
      return {
        color: isOnPrem ? 'purple' : 'blueviolet',
        label: isOnPrem ? 'On Premisse (Rep-P)' : 'SaaS (Rep-P)',
      };
    }

    return { color: '', label: '' };
  };

  const { color, label } = getStatus();

  if (isPedido) {
    return (
      <Chip
        label={label}
        variant="outlined"
        size="small"
        sx={{ color, border: `1px solid ${color}`, fontWeight: 'bold' }}
      />
    );
  }

  return (
    <td style={{ fontSize: "small", color, fontWeight: "bold" }}>
      {label}
    </td>
  );
}
